import React, { useEffect, useState } from "react";
import { LuSendHorizonal } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { getTypeFieldByListNameAction } from "../../Actions/TypeFieldAction/TypeFieldAction";
import {
  createMedicalSupliesAction,
  updateMedicalSupliesAction,
} from "../../Actions/MedicalSupliesAction/MedicalSupliesAction";
import { udpateUndergoneSurgeryAction } from "../../Actions/UndergoneSurgeryAction/UndergoneSurgeryAction";
import { getTypeOfHeAction } from "../../Actions/SurgeryAction/TypeOfHelpAction";
import { getHospitalAction } from "../../Actions/HospitalAction/HospitalAction";
import Input from "../../Buttons/Input";

const MedicalSuplies = ({
  typeOfHelpList,
  visit,
  branchId,
  visitId,
  patientId,
  closeModal,
}) => {
  const { hospitals } = useSelector((state) => state.getHospital);

  const hospitalList = hospitals?.map((hospital) => ({
    value: hospital.id,
    label: hospital.name + " - " + hospital.branch?.name,
  }));

  const valuesToRemove = ["نەشتەرگەری", "پێداویستی پزیشکی"];
  const [typeList, setTypeList] = useState([]);
  const dispatch = useDispatch();
  const updatedList = typeOfHelpList.filter(
    (item) => !valuesToRemove.includes(item)
  );
  useEffect(() => {
    const updatedList = typeOfHelpList.filter(
      (item) => !valuesToRemove.includes(item)
    );
    setTypeList(updatedList);
  }, [typeOfHelpList]);

  useEffect(() => {
    dispatch(getHospitalAction(0, 5000, ""));
  }, []);
  const createMedicalSuplies = useSelector(
    (state) => state.createMedicalSuplies
  );
  const { medicalSuplies } = createMedicalSuplies;

  const [state, setState] = useState({
    city: "",
    hospitalName: "",
    cost: "",
    date: "",
  });
  const [typeTest, setTypeTest] = useState([]);
  const handleStateChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };
  useEffect(() => {
    if (typeList) {
      dispatch(getTypeFieldByListNameAction(updatedList));
    } else {
      return null;
    }
  }, [typeOfHelpList]);
  const getTypeFieldByListName = useSelector(
    (state) => state.getTypeFieldByListName
  );
  const { fieldList } = getTypeFieldByListName;
  const [errors, setErrors] = useState({});
  useEffect(() => {
    dispatch(getTypeOfHeAction());
  }, []);
  const getTypeOfHelp = useSelector((state) => state.getTypeOfHelp);

  const [validHelps, setValidHelps] = useState([]);
  useEffect(() => {
    if (getTypeOfHelp && Array.isArray(getTypeOfHelp.typeOfHelps)) {
      const { typeOfHelps } = getTypeOfHelp;

      const newValidHelps = typeOfHelps.filter((help) =>
        validateHelp(help, typeList)
      );
      setValidHelps(newValidHelps);
    }
  }, [getTypeOfHelp]);

  const validateHelp = (help, validValues) => {
    return validValues.includes(help.name);
  };
  const validate = () => {
    const newErrors = {};
    if (!branchId) {
      newErrors.branch = "Branch is required.";
    }
    if (!state.city.trim()) {
      newErrors.city = "City is required.";
    }

    if (!state.cost.trim()) {
      newErrors.cost = "Cost is required.";
    }

    if (!state.date.trim()) {
      newErrors.date = "Date is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  useEffect(() => {

    if (updatedList == undefined || updatedList?.length <= 0) {
      return;
    }
    if (visit?.medical_suplies?.length > 0) {
      let list = [];
      console.log(visit," visit :s ")
      visit?.medical_suplies?.map((medical) => {

        list.push(medical.type_of_test);

        setState({
          ...state,
          cost: medical.cost,
          hospitalName: medical?.hospitals?.map((hospital) => ({
            label: hospital?.name,
            value: hospital.id,
          })),

          date: medical.date,
          city: medical.place,
        });
      });
      setTypeTest(list);
      return;
    } else if (visit?.medical_suplies?.length <= 0) {
      fieldList?.map((field) => {
        if (typeTest.length < fieldList.length) {
          setTypeTest([...typeTest, ""]);
        }
      });
      return;
    }
  }, [fieldList, visit]);
  const handleUpdate = () => {
    if (!validate()) {
      return;
    }

    closeModal();
    dispatch(
      udpateUndergoneSurgeryAction(
        visit?.undergone_surgery_or_suplies?.id,
        visitId,
        0,
        1,
        state.date
      )
    );
    if (visit?.medical_suplies?.length > 0) {

      let ids = [];
      if (medicalSuplies?.length > 0) {
        medicalSuplies?.map((medical) => {
          ids.push(medical.id);
        });
      } else {
        visit?.medical_suplies?.map((medical) => {
          ids.push(medical.id);
        });
      }

      dispatch(
        updateMedicalSupliesAction(
          ids,
          branchId,
          visitId,
          state.city,
          state.hospitalName,
          state.cost,
          state.date,
          updatedList,
          typeTest,
          patientId
        )
      );
      return;
    } else {

      dispatch(
        createMedicalSupliesAction(
          branchId,
          visitId,
          state.city,
          state.hospitalName,
          state.cost,
          state.date,
          updatedList,
          typeTest,
          patientId
        )
      );
    }
  };

  return (
    <div>
      {updatedList == undefined || updatedList?.length <= 0 ? (
        ""
      ) : (
        <div className="bg-blue-500 rounded-sm shadow-md md:w-5/12 lg:w-2/12 text-white m-auto p-2 text-center mt-3">
          پێداویستی پزیشکی
        </div>
      )}

      {updatedList == undefined || updatedList?.length <= 0 ? (
        <p className="text-center font-bold text-xl text-red-500 mt-4">
          تکایە جۆری پێداویسیت پزیشکی هەڵبژێرە
        </p>
      ) : (
        <div className="grid grid-cols-1 gap-2 lg:grid-cols-3">
          <div className="flex flex-col ">
            <label htmlFor="fullname">Full Name</label>
            <input
              type="text"
              id="fullname"
              value={visit.patient.patient_info.fullname}
              className="input"
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="typeHelp">Type Of Help</label>
            <input
              type="text"
              value={typeList}
              id="typeHelp"
              className="input"
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="Cityofresidence" className="capitalize">
              City of residence
            </label>
            <input
              name="city"
              type="text"
              value={state.city || ""}
              onChange={handleStateChange}
              id="Cityofresidence"
              className="input"
            />
            {errors.city && <p className="text-red-500">{errors.city}</p>}
          </div>

          <div className="flex flex-col">
            {/* <Select */}
            <Input
              isMutli={true}
              type={"select"}
              options={hospitalList}
              name={"hospitalName"}
              label={"hospital Name"}
              placeholder={"Hospital"}
              setFormData={setState}
              formData={state}
            />

            {errors.hospitalName && (
              <p className="text-red-500">{errors.hospitalName}</p>
            )}
          </div>

          <div className="flex flex-col">
            <label htmlFor="cost" className="capitalize">
              Cost
            </label>
            <input
              type="text"
              value={state.cost}
              name="cost"
              onChange={handleStateChange}
              id="cost"
              className="input"
            />
            {errors.cost && <p className="text-red-500">{errors.cost}</p>}
          </div>

          <div className="flex flex-col">
            <label htmlFor="date" className="capitalize">
              date
            </label>
            <input
              type="date"
              value={state.date}
              name="date"
              onChange={handleStateChange}
              id="date"
              className="input"
            />
            {errors.date && <p className="text-red-500">{errors.date}</p>}
          </div>
        </div>
      )}

      {validHelps?.map((type, typeIndex) => (
        <div key={typeIndex}>
          <div
            className={`bg-indigo-500 p-2 mt-2 rounded-sm m-auto lg:w-2/12 text-white text-center`}
          >
            {type.name}
          </div>

          {type?.type_field?.map((field, fieldIndex) => (
            <div key={`${typeIndex}-${fieldIndex}`}>
              {field.type === "dropdown" && (
                <div className="flex flex-col">
                  <div>
                    <label>{field.label} *</label>
                  </div>

                  <select
                    name={field.name}
                    onChange={(e) => {
                      const { name, value } = e.target;
                      const newValue = [...typeTest];
                      // console.log()
                      newValue[typeIndex] = value;
                      // console.log(newValue);
                      setTypeTest(newValue);
                    }}
                    className="input"
                  >
                    <option value="">Select Type</option>
                    {field.type_field_value.map((value, valueIndex) => (
                      <option
                        value={value.value}
                        key={`${typeIndex}-${fieldIndex}-${valueIndex}`}
                      >
                        {value.value}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          ))}
        </div>
      ))}

      {/* {fieldList?.map((field, index) => {
        return (
          
        );
      })} */}
      {errors.branch && (
        <div
          class="bg-red-100 border mt-2 border-red-400 text-red-700 px-4 py-3 rounded relative"
          role="alert"
        >
          <strong class="font-bold">Select Branch!</strong>
          <span class="block sm:inline">
            {" "}
            {errors.branch && <p className="">{errors.branch}</p>}
          </span>
          <span
            onClick={() => setErrors({})}
            class="absolute top-0 bottom-0 right-0 px-4 py-3"
          >
            <svg
              class="fill-current h-6 w-6 text-red-500"
              role="button"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <title>Close</title>
              <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
            </svg>
          </span>
        </div>
      )}
      {updatedList == undefined || updatedList?.length <= 0 ? (
        ""
      ) : (
        <button
          onClick={handleUpdate}
          className="btn-primary mt-2 flex gap-2 items-center"
        >
          Send <LuSendHorizonal />
        </button>
      )}
    </div>
  );
};

export default MedicalSuplies;
